import styled from 'styled-components';
import {
  Form,
} from 'antd';
import { COLOR_RED, COLOR_WHITE } from 'constants/colors';
import { Button, Input } from 'UI';
import { MinusCircleOutlined } from '@ant-design/icons';

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem;
  background-color: ${COLOR_WHITE};
`;

export const InlineButton = styled(Button)`
  display: inline-flex;
  width: auto;
`;

export const BaseFormItem = styled(Form.Item)`
  margin: 0;
  width: 100%;
  padding-bottom: 1.5rem;

  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
  }
`;

export const InlineFormGroup = styled.div`
  margin: 0;
  width: 100%;
  padding-bottom: 1.5rem;
  display: flex;

  & ${BaseFormItem.toString()} {
    padding-bottom: 0;
    max-width: 376px;

    &:first-child {
      margin-right: 1.5rem;
    }
  }
`;

export const CapacityInput = styled(Input)`
  width: fit-content;
`;

export const ResourcesTitle = styled.h3`
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
`;

export const ResourceFormItem = styled(BaseFormItem)`
  width: 40%;
`;

export const AddResourceButton = styled(Button)`
  width: 40%;
`;

export const RemoveResourceButton = styled(Button)`
  width: fit-content;
  background: transparent;
  border: 0;
  border-radius: 24px;
  box-shadow: none;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:active,
  &:focus {
    background: transparent;
  }
`;

export const RemoveResourceIcon = styled(MinusCircleOutlined)`
  font-size: 24px;
  color: ${COLOR_RED};
`;

export const ResourceFormRow = styled.div`
  margin: 0;
  width: 100%;
  padding-bottom: 1.5rem;
  display: flex;
  align-items: flex-end;
  gap: 1.5rem;

  & ${BaseFormItem.toString()} {
    padding-bottom: 0;
    max-width: 376px;
  }
`;
